"use client";

import React, { PropsWithChildren, useEffect } from "react";
import { SessionProvider, signIn, signOut, useSession } from "next-auth/react";
import { Session } from "next-auth";

interface AuthProviderProps {
  children: React.ReactNode;
  session?: Session | null;
}

function AuthGuard({ children }: PropsWithChildren) {
  const { data: session, status } = useSession();

  useEffect(() => {
    if (
      session?.error === "RefreshAccessTokenExpired" ||
      session?.error === "RefreshAccessTokenError"
    ) {
      const handleLogout = async () => {
        await signOut({
          callbackUrl: process.env.NEXT_PUBLIC_LANDING_URL + "/",
          redirect: false,
        });

        window.location.href = `${process.env.NEXT_PUBLIC_LANDING_URL}/auth`;
      };

      handleLogout();
    }
  }, [session?.error]);

  if (status === "loading") {
    return null;
  }

  return children;
}

export function AuthProvider({ children, session }: AuthProviderProps) {
  return (
    <SessionProvider
      session={session}
      basePath={process.env.NEXT_PUBLIC_LANDING_URL + "/api/auth"}
      refetchOnWindowFocus={false}
    >
      <AuthGuard>{children}</AuthGuard>
    </SessionProvider>
  );
}
